import { renderToString } from "react-dom/server"
import { StaticRouter } from "react-router-dom/server"
import App from "./App"

export async function prerender(url: string) {
  const html = renderToString(
    <StaticRouter location={url}>
      <App />
    </StaticRouter>
  )

  return {
    html,
    head: {
      headTags: "",
      htmlAttrs: "",
      bodyAttrs: "",
      bodyTagsOpen: "",
      bodyTags: "",
    },
  }
}
